import BaseAPI from "../api";

const path: string = "indicators";

interface indicatorsType {
  keyword?: string;
  page?: string;
  limit?: string;
}

export class IndicatorsApi extends BaseAPI {
  static GetIndicators(props: indicatorsType): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
}
